import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        currentRowId: null,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                source: null,
                model: null,    //当source不为空时,传入对应的菜单/模块ID
                type: null,
                status: true,
                like_name: null,
                like_code: null,
                like_description: null,
            },
        },
        resourcesTypes: [
            {
                id: 2,
                name: '按钮'
            },
            {
                id: 3,
                name: '组件'
            },
            {
                id: 4,
                name: '接口'
            }
        ],
    },
    getters: {
        ['PermissionResourceListGetCurrentRowId'](state) {
            return state.currentRowId;
        },
        ["PermissionResourceListGetPageSearch"](state) {
            return state.pageSearch;
        },
        ["PermissionResourceListGetPageCurrent"](state) {
            return state.pageSearch.current;
        },
        ["PermissionResourceListGetPageSize"](state) {
            return state.pageSearch.size;
        },
        ["PermissionResourceListGetPageTotal"](state) {
            return state.page.total;
        },
        ["PermissionResourceListGetPageSearchSearch"](state) {
            return state.pageSearch.search;
        }
    },
    mutations: {
        ['PermissionResourceListSetCurrentRowId'](state, currentRowId) {
            state.currentRowId = currentRowId;
        },
        ['PermissionResourceListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['PermissionResourceListSetPage'](state, page) {
            state.page = page;
        },
        ['PermissionResourceListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['PermissionResourceListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['PermissionResourceListSetPageCurrent'](state, current) {
            state.pageSearch.current = current;
        },
        ['PermissionResourceListSetPageSize'](state, size) {
            state.pageSearch.size = size;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit("PermissionResourceListSetLoading", true);
            let res = await OrganizationServer.permission.resourcesPage(params);
            if (res.data.code == null || res.data.code === '200') {
                res.data.data.records.forEach(r => {
                    if (r.description === null) {
                        r.description = '-';
                    }
                });
                if (res.data.data.records.length > 0) {
                    console.log("currentRowId", res.data.data.records[0].id);
                    commit('PermissionResourceListSetCurrentRowId', res.data.data.records[0].id);
                }
                commit('PermissionResourceListSetPage', res.data.data);
            }
            commit("PermissionResourceListSetLoading", false);
            return Promise.resolve();
        }
    }
}
